import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { IngredientChoice, OrderableIngredient, OrderedIngredient, OrderedChoice, OrderedChoiceService, StoreConfig } from 'ngx-web-api';
import { IngredientSelection } from '../../../../domain/ingredient-selection';
import { HalfsOrderingService } from 'app/core/services/halfs-ordering.service';

@Component({
  selector: 'fts-ingredient',
  templateUrl: './ingredient.component.html',
  styleUrls: ['./ingredient.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IngredientComponent implements OnChanges {
  @Input()
  ingredient: OrderableIngredient;
  @Input()
  itemSize: string;
  @Input()
  singleSelectionChoiceSelectedIngredient: OrderedIngredient;
  @Input()
  choice: IngredientChoice;
  @Input()
  disabled: boolean;
  @Input()
  isInModal: boolean;
  @Input()
  ingredientIndex: number;
  @Input()
  hasGraphicalBuilder: boolean;
  @Input()
  orderedChoice: OrderedChoice;
  @Input()
  needsMaxIngredientsWarningsCheck: boolean;
  @Input()
  storeConfig: StoreConfig;
  @Input()
  inItemEditorModal = false;
  @Input()
  hasTags: boolean;
  @Input()
  hasTagList: boolean;

  @Output()
  ingredientSelectedChange: EventEmitter<OrderableIngredient> = new EventEmitter();
  @Output()
  ingredientHalfChange: EventEmitter<IngredientSelection> = new EventEmitter();
  @Output()
  ingredientQualifierChange: EventEmitter<IngredientSelection> = new EventEmitter();
  @Output()
  tagClicked: EventEmitter<string> = new EventEmitter<string>();

  orderedIngredient: OrderedIngredient;
  isHalfAndHalf: boolean;

  constructor(private orderedChoiceService: OrderedChoiceService, private halfsOrderingService: HalfsOrderingService) {
    this.isHalfAndHalf = this.halfsOrderingService.isHalfAndHalf.getValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['orderedChoice'] || changes['ingredient']) && !!this.orderedChoice && !!this.ingredient) {
      const tempIng = this.orderedChoiceService.getIngredient(this.orderedChoice, this.ingredient);
      if (!this.isHalfAndHalf || tempIng || !tempIng) {
        this.orderedIngredient = tempIng;
      }
    }
  }

  toggleIngredient() {
    if (this.halfsOrderingService.isHalfAndHalf.getValue() && this.ingredient.allowHalves) {
      this.halfsOrderingService.addOrRemoveIngredientToHalfOrderedItem(this.ingredient, this.choice.name);
    } else {
      this.ingredientSelectedChange.emit(this.ingredient);
    }
  }

  selectHalf(halfSelection: IngredientSelection) {
    if (this.choice.defaultsNonRemovable && this.ingredient.isDefault) {
      return;
    }
    this.ingredientHalfChange.emit(halfSelection);
  }

  toggleQualifier(qualifier: IngredientSelection) {
    this.ingredientQualifierChange.emit(qualifier);
  }
}
